import { PaginationProps, Sex, SortDirection } from 'utilities'

export enum ViewersTableSortProps {
  NAME = 'name',
  DYNAMIC_COL = 'dynamic column'
}

export interface ViewersTableSearchProps {
  fullName: string
  email: string
  sex: Sex
}

export const initialViewersPaginationProps: PaginationProps<
  ViewersTableSortProps
> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.ASC,
  sortProp: ViewersTableSortProps.NAME,
  totalElements: 0,
  totalPages: 0
}

export const initialViewersSearchProps: ViewersTableSearchProps = {
  fullName: '',
  email: '',
  sex: '' as Sex
}
